import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import { ContentWidthEnum } from 'common/types/styleTypes'
import React from 'react'
import { Switcher } from 'src/editor/shared/ui-lib/switcher'
import { getMobileOrDesktop } from 'src/shared/utils/get-mobile-or-desktop'

const contentWidthOptions = [
  {
    content: ContentWidthEnum.xs.toUpperCase(),
    value: ContentWidthEnum.xs,
  },
  {
    content: ContentWidthEnum.s.toUpperCase(),
    value: ContentWidthEnum.s,
  },
  {
    content: ContentWidthEnum.m.toUpperCase(),
    value: ContentWidthEnum.m,
  },
  {
    content: ContentWidthEnum.l.toUpperCase(),
    value: ContentWidthEnum.l,
  },
  {
    content: ContentWidthEnum.xl.toUpperCase(),
    value: ContentWidthEnum.xl,
  },
]

interface ContentWidthControlProps {
  contentWidth?: ContentWidthEnum
  mobileContentWidth?: ContentWidthEnum
  update: (value: ContentWidthEnum) => void
  mobileUpdate?: (value: ContentWidthEnum) => void
  label?: string
}

export const ContentWidthControl = ({
  contentWidth = ContentWidthEnum.m,
  mobileContentWidth,
  update,
  mobileUpdate,
  label = 'website_styles_settings.content_width.label',
}: ContentWidthControlProps) => {
  const { isMobile } = useDeviceModeContext()

  const resultContentWidth = getMobileOrDesktop(
    contentWidth,
    mobileContentWidth,
    isMobile,
  )
  const resultUpdate = getMobileOrDesktop(update, mobileUpdate, isMobile)

  return (
    <Switcher
      labelText={label}
      btnList={contentWidthOptions}
      value={resultContentWidth}
      update={resultUpdate}
    />
  )
}
